import { useReportContext } from "@/context/ReportContext";
import { useAccountLists } from "@/dashboard/AccountLists/useAccountLists/useAccountLists";
import type { LizanoListInfo } from "@/reports/sections/ListsSection/lists/lists";

const findIfAReportIsInAList = ({
  lists,
  permalink,
}: {
  lists: LizanoListInfo[] | undefined;
  permalink: string;
}) => {
  let found = false;
  const filteredLists = lists?.filter((list) => list.name !== "saved reports");
  if (filteredLists) {
    for (const list of filteredLists) {
      if (list?.list_reports) {
        for (const report of list.list_reports) {
          if (report?.report?.permalink === permalink) {
            found = true;
          }
        }
      }
    }
  }
  return found;
};

export function useListAction() {
  const { data: lists, createList } = useAccountLists();
  const { permalink } = useReportContext();
  const foundInList = findIfAReportIsInAList({ lists, permalink });

  return {
    createList,
    foundInList,
    lists,
  };
}
